<template>
    <div class="el-notice">
        <el-row class="page_content">
            <el-row style="border-bottom:2px solid #f0f2f5;">
                <el-col :span="20"><h1 style="margin-left:10px;">通知公告</h1></el-col>
            </el-row>
            <div style="height:calc(100% - 130px);overflow-y:auto;">
                <el-row style="border-bottom:1px solid #f0f2f5;" v-for='(item,index) in noticeList' :key="index" class="notice" @click.native="getNoticeInfo(index)">
                    <el-col :span="20">
                      <p style="margin-left:10px;float: left;">
                        <span class="spanClass" :style="item.messageAcceptState == 2?'background:red;':''">&nbsp;</span>
                        通知：
                      </p>
                      <el-row class="limit_line_one" style="width: 80%;line-height:25px;" v-html="item.messageTitle"></el-row>
                    </el-col>
                    <el-col :span="4" style="text-align:center;"><p style="margin-right:10px;">{{item.messageAddTime}}</p></el-col>
                </el-row>
                <el-empty v-if="noticeList.length <= 0" description="暂无通知公告数据"></el-empty>
            </div>
            <div class="block" style="text-align: center;position: absolute;bottom: 0;width: 96%;margin-bottom: 20px;">
                <el-pagination
                    @size-change="handleSizeChange"
                    @current-change="handleCurrentChange"
                    :current-page.sync="currentPage1"
                    :page-size="limit"
                    :hide-on-single-page="true"
                    layout="total, prev, pager, next"
                    :total="total">
                </el-pagination>
            </div>
        </el-row>
        <el-dialog
            title=""
            :visible.sync="show"
            width="1000px"
            >
            <el-descriptions :colon="false" >
                <el-descriptions-item label="标题："><span v-html="noticeInfo.messageTitle"></span></el-descriptions-item>
            </el-descriptions>
            <el-descriptions :colon="false">
                <el-descriptions-item label="时间：">{{noticeInfo.messageAddTime}} </el-descriptions-item>
            </el-descriptions>
            <el-descriptions :colon="false">
                <el-descriptions-item label="内容："><el-row v-html="noticeInfo.messageConcat"></el-row></el-descriptions-item>
            </el-descriptions>
            <el-descriptions :colon="false" v-if="!$isEmpty(noticeInfo.courseResourceList)">
                <el-descriptions-item label="附件：">
                    <template v-for="(item,index) in noticeInfo.courseResourceList">
                        <p>
                            <el-link :underline="false" type="primary" style="padding: 0;" :href="$isHttp(item.courseResourceUrl)">
                                {{item.courseResourceName}}
                            </el-link>
                        </p>
                    </template>
                </el-descriptions-item>
            </el-descriptions>
            <!-- <span slot="footer" class="dialog-footer">
                <el-button type="primary" @click="show = false">确 定</el-button>
            </span> -->
        </el-dialog>
    </div>
</template>
<script>
export default {
  name: "Notice",
  data() {
    return {
      show:false,
      noticeInfo:{},
      noticeList:[], //当前页数据
      currentPage1: 1,
      total: 0,
      limit:10,
      page:1
    };
  },
  created() {
   this.getNoticeList();
  },
  methods: {
    handleSizeChange(val) {
        console.log(`每页 ${val} 条`);
        this.limit = val;
        this.getNoticeList();
    },
    handleCurrentChange(val) {
        console.log(`当前页: ${val}`);
        this.page = val;
        this.getNoticeList();
    },
    getNoticeList(){ //获取通知公告列表
      this.$store.dispatch("user/getNoticeList",{limit:this.limit,page:this.page})
      .then((ret) => {
        if(ret.code == 0){
          this.noticeList = ret.data;
          this.total = ret.count;
        }else{
          this.$message({
             message: ret.msg,
             type: "warning"
          });
        }
      });
    },
    getNoticeInfo(index){ //获取通知公告详情
      this.$store.dispatch("user/getNoticeInfo",{messageId:this.noticeList[index].messageId})
      .then((ret) => {
        if(ret.code == 0){
          this.show = true;
          this.noticeList[index].messageAcceptState = 1;
          this.noticeInfo = ret.data;
        }else{
          this.$message({
             message: ret.msg,
             type: "warning"
          });
        }
      });
    }
  }
};
</script>
<style  lang="less">
  @import '../styles/base.less';
  .el-notice{
    .el-descriptions-item__content p{
      margin: 0;
    }
    .spanClass{
        background: #73a1f7;
        float: left;
        width: 10px;
        height: 10px;
        margin: 7px 10px;
        }
        .notice{
        cursor: pointer;
        }
        .notice:hover{
        background-color: rgb(129, 211, 248);
        color: white;
    }
    .el-link.el-link--primary{
        padding: 0 30px;
    }
    .sj{
        color: #a2a2a2;
    }
    .curriculum p{
        text-indent: 2em;
    }
    .el-descriptions-item__container{
        font-size: 15px;
    }
    .el-descriptions-item__label {
        white-space: nowrap;
    }
    // .el-descriptions-item__content{
    //     max-height: 200px;
    //     overflow: auto;
    // }
  }
</style>



// WEBPACK FOOTER //
// src/pages/Notice.vue